module.exports = __webpack_public_path__ + "static/media/_MIC2287.thumbnail.24864896.png";